import Navbar from "components/MI/Navbar";
import React from "react";
import UserMenu from "components/layout/userMenuNew";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiRightArrowAlt } from "react-icons/bi";

import { usePesquisaPage } from "../hooks/usePesquisaPage";
import {
  Container,
  Content,
  ContentFirst,
  ContentItem,
  ContentTitle,
  Title,
} from "../styles";

const PesquisaPage = (): JSX.Element => {
  const { searchResult, search } = usePesquisaPage();

  return (
    <Navbar selected="pesquisar">
      <UserMenu />
      <Container>
        <Title>Pesquisa</Title>
        {searchResult?.length ? (
          <p>
            Resultado da busca por <strong>{search}</strong>
          </p>
        ) : (
          <p>
            Nenhum item foi encontrado na busca por <strong>{search}</strong>
          </p>
        )}

        {searchResult?.length ? (
          <Content>
            {searchResult?.map((a) => (
              <ContentItem key={a?.key} to={a?.url} target={a?.target}>
                <ContentFirst>
                  <AiOutlineFileSearch />
                  <ContentTitle>{a?.title}</ContentTitle>
                </ContentFirst>
                <BiRightArrowAlt />
              </ContentItem>
            ))}
          </Content>
        ) : null}
      </Container>
    </Navbar>
  );
};

export default PesquisaPage;
